import React from 'react';
import { Header, Icon, Message, Button, Grid, Form, Segment, Label } from 'semantic-ui-react';
import {
  formatCpfProgressive,
  cleanCpf,
  toBrazilNationalPhoneDigits,
  formatPhoneProgressive,
  isValidPhoneFormat,
} from '../../services/utils/stringUtils';

export interface ContractFormAdministradorTabProps {
  adminNomeCompleto: string;
  setAdminNomeCompleto: React.Dispatch<React.SetStateAction<string>>;
  adminCpf: string;
  setAdminCpf: React.Dispatch<React.SetStateAction<string>>;
  adminRg: string;
  setAdminRg: React.Dispatch<React.SetStateAction<string>>;
  adminEmail: string;
  setAdminEmail: React.Dispatch<React.SetStateAction<string>>;
  adminTelefone1: string;
  setAdminTelefone1: React.Dispatch<React.SetStateAction<string>>;
  adminTelefone2: string;
  setAdminTelefone2: React.Dispatch<React.SetStateAction<string>>;
}

export const ContractFormAdministradorTab: React.FC<ContractFormAdministradorTabProps> = ({
  adminNomeCompleto,
  setAdminNomeCompleto,
  adminCpf,
  setAdminCpf,
  adminRg,
  setAdminRg,
  adminEmail,
  setAdminEmail,
  adminTelefone1,
  setAdminTelefone1,
  adminTelefone2,
  setAdminTelefone2,
}) => {
  const clearAdmin = () => {
    setAdminNomeCompleto('');
    setAdminCpf('');
    setAdminRg('');
    setAdminEmail('');
    setAdminTelefone1('');
    setAdminTelefone2('');
  };

  return (
    <div style={{ padding: '20px' }}>
      <Header as="h3" style={{ color: '#2c3e50', marginBottom: '20px' }}>
        <Icon name="user secret" />
        Responsável pela Auditoria (Em ligação)
      </Header>

      <Message info style={{ marginBottom: '20px', backgroundColor: '#e3f2fd', borderLeft: '4px solid #2196f3' }}>
        <Message.Header>
          <Icon name="phone" />
          Quem é o Responsável pela Auditoria?
        </Message.Header>
        <p style={{ fontSize: '14px', lineHeight: '1.6', marginTop: '10px' }}>
          <strong>O Responsável pela Auditoria é a pessoa que está na ligação com o vendedor</strong> e atua como
          <strong style={{ color: '#1976d2' }}> intermediário para a empresa</strong>.
        </p>
        <p style={{ fontSize: '14px', lineHeight: '1.6', marginTop: '8px', marginBottom: '0' }}>
          Esta pessoa será contatada durante o processo de CQV (Confirmação de Qualidade de Venda) e será responsável
          pela auditoria do contrato. Ela não precisa ser um QSA ou dono da empresa, apenas alguém que representa a
          empresa na contratação.
        </p>
      </Message>

      {(adminNomeCompleto || adminCpf || adminRg || adminEmail) && (
        <Segment
          style={{
            backgroundColor: '#f8f9fa',
            marginBottom: '20px',
            border: '2px solid #007bff',
          }}
        >
          <Header as="h4" style={{ color: '#2c3e50' }}>
            <Icon name="user" />
            Responsável pela Auditoria
            <Label color="blue" size="small" style={{ marginLeft: '10px' }}>
              <Icon name="edit" />
              Inserido Manualmente
            </Label>
          </Header>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={8}>
                <p>
                  <strong>Nome:</strong> {adminNomeCompleto || 'Não informado'}
                </p>
                <p>
                  <strong>CPF:</strong> {adminCpf || 'Não informado'}
                </p>
                <p>
                  <strong>RG:</strong> {adminRg || 'Não informado'}
                </p>
              </Grid.Column>
              <Grid.Column width={8}>
                <p>
                  <strong>Email:</strong> {adminEmail || 'Não informado'}
                </p>
                <p>
                  <strong>Telefone:</strong> {adminTelefone1 || 'Não informado'}
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Button size="small" color="orange" onClick={clearAdmin} style={{ marginTop: '10px' }}>
            <Icon name="edit" />
            Editar Dados
          </Button>
        </Segment>
      )}

      {!adminNomeCompleto && (
        <Message info style={{ marginBottom: '20px' }}>
          <Message.Header>
            <Icon name="info circle" />
            Informação
          </Message.Header>
          <p>
            Por favor, preencha os dados do responsável pela auditoria manualmente abaixo. O responsável pela auditoria
            é quem está na ligação com o vendedor e atua como intermediário para a empresa.
          </p>
        </Message>
      )}

      <Form>
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Form.Field required>
                <label>Nome Completo</label>
                <input
                  type="text"
                  placeholder="Nome completo do responsável pela auditoria"
                  value={adminNomeCompleto}
                  onChange={(e) => setAdminNomeCompleto(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Field required>
                <label>CPF</label>
                <input
                  type="text"
                  placeholder="000.000.000-00"
                  value={formatCpfProgressive(adminCpf)}
                  onChange={(e) => {
                    const cleanedValue = cleanCpf(e.target.value);
                    setAdminCpf(cleanedValue);
                  }}
                  maxLength={14}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                />
                <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                  Aceita CPF com ou sem formatação (11 dígitos)
                </div>
              </Form.Field>
            </Grid.Column>

            <Grid.Column width={8}>
              <Form.Field>
                <label>RG (opcional)</label>
                <input
                  type="text"
                  placeholder="Número do RG"
                  value={adminRg}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').substring(0, 10);
                    setAdminRg(value);
                  }}
                  maxLength={10}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                />
                <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                  Máximo 10 dígitos (opcional)
                </div>
              </Form.Field>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Field required>
                <label>Email *</label>
                <input
                  type="email"
                  placeholder="email@exemplo.com"
                  value={adminEmail}
                  onChange={(e) => setAdminEmail(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Field error={!!adminTelefone1 && !isValidPhoneFormat(adminTelefone1)}>
                <label>Telefone Principal *</label>
                <input
                  type="tel"
                  placeholder="(41) 99999-9999"
                  value={formatPhoneProgressive(adminTelefone1)}
                  onChange={(e) => {
                    setAdminTelefone1(toBrazilNationalPhoneDigits(e.target.value));
                  }}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border:
                      adminTelefone1 && !isValidPhoneFormat(adminTelefone1)
                        ? '2px solid #e74c3c'
                        : '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor:
                      adminTelefone1 && !isValidPhoneFormat(adminTelefone1) ? '#fff5f5' : 'white',
                  }}
                />
                {adminTelefone1 && !isValidPhoneFormat(adminTelefone1) ? (
                  <div style={{ fontSize: '12px', color: '#e74c3c', marginTop: '4px', fontWeight: '600' }}>
                    ⚠️ Telefone deve ter 10 dígitos (fixo) ou 11 dígitos (celular com 9 na frente)
                  </div>
                ) : adminTelefone1 && isValidPhoneFormat(adminTelefone1) ? (
                  <div style={{ fontSize: '12px', color: '#27ae60', marginTop: '4px', fontWeight: '600' }}>
                    ✓ Telefone válido
                  </div>
                ) : (
                  <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                    Exemplo: (41) 99999-9999 (celular) ou (41) 3333-9999 (fixo)
                  </div>
                )}
              </Form.Field>
            </Grid.Column>

            <Grid.Column width={8}>
              <Form.Field error={!!adminTelefone2 && !isValidPhoneFormat(adminTelefone2)}>
                <label>Telefone Secundário</label>
                <input
                  type="tel"
                  placeholder="(41) 88888-8888"
                  value={formatPhoneProgressive(adminTelefone2)}
                  onChange={(e) => {
                    setAdminTelefone2(toBrazilNationalPhoneDigits(e.target.value));
                  }}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border:
                      adminTelefone2 && !isValidPhoneFormat(adminTelefone2)
                        ? '2px solid #e74c3c'
                        : '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor:
                      adminTelefone2 && !isValidPhoneFormat(adminTelefone2) ? '#fff5f5' : 'white',
                  }}
                />
                {adminTelefone2 && !isValidPhoneFormat(adminTelefone2) ? (
                  <div style={{ fontSize: '12px', color: '#e74c3c', marginTop: '4px', fontWeight: '600' }}>
                    ⚠️ Telefone deve ter 10 dígitos (fixo) ou 11 dígitos (celular com 9 na frente)
                  </div>
                ) : adminTelefone2 && isValidPhoneFormat(adminTelefone2) ? (
                  <div style={{ fontSize: '12px', color: '#27ae60', marginTop: '4px', fontWeight: '600' }}>
                    ✓ Telefone válido
                  </div>
                ) : (
                  <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                    Exemplo: (41) 99999-9999 (celular) ou (41) 3333-9999 (fixo)
                  </div>
                )}
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>

      <Message warning style={{ marginTop: '15px' }}>
        <Message.Header>
          <Icon name="exclamation triangle" />
          Importante
        </Message.Header>
        <p style={{ marginTop: '8px' }}>
          <strong>O responsável pela auditoria é quem está na ligação com o vendedor</strong> e atua como
          <strong> intermediário para a empresa</strong>. Esta pessoa será contatada durante o processo de CQV
          (Confirmação de Qualidade de Venda) para confirmar os detalhes da contratação.
        </p>
        <p style={{ marginTop: '8px', marginBottom: '0' }}>
          Certifique-se de que todos os dados estejam corretos e atualizados, especialmente o <strong>telefone</strong> e
          <strong> email</strong>, pois serão usados para contato durante a auditoria.
        </p>
      </Message>
    </div>
  );
};
